import cx from "classnames";

import Button from "metabase/common/components/Button";
import Link from "metabase/common/components/Link";
import CS from "metabase/css/core/index.css";
import { Box, Flex, Text } from "metabase/ui";

import S from "./AdminPaneTitle.module.css";
import type { AdminPaneProps } from "./types";

export const AdminPaneTitle = ({
  title,
  description,
  buttonText,
  buttonIcon,
  buttonAction,
  buttonDisabled,
  buttonLink,
  headingContent,
  isPeopleListing,
}: AdminPaneProps) => {
  const buttonClassName = cx(CS.mlAuto, CS.flexNoShrink);
  return (
    <Box className={S.PaneTitle}>
      <Flex className={S.PaneHeader}>
        <Box className={isPeopleListing ? S.PanelSubheader : ""}>
          {headingContent && <div>{headingContent}</div>}
          {title && (
            <h2 data-testid="admin-pane-page-title" className={CS.m0}>
              {title}
            </h2>
          )}
          {description && <Text maw="40rem">{description}</Text>}
        </Box>
        <Box>
          {buttonText && buttonLink && (
            <Link to={buttonLink} className={isPeopleListing ? '' : buttonClassName} style={isPeopleListing ? {backgroundColor: "transparent"} : {}}>
              <Button primary className={isPeopleListing ? '' : S.PaneButton}  style={ isPeopleListing ? {backgroundColor: "#226594", borderRadius: "999px", display: "flex", gap: "0.5rem", border: "none", justifyContent: "center", alignItems: "center"} : {}}>
                {buttonIcon && <span className={isPeopleListing ? '' : S.ButtonIcon} style={isPeopleListing ? {margin: "0"} : {}}>{buttonIcon}</span>}
                <span style={isPeopleListing ? {color: "white"} : {}}>{buttonText}</span>
              </Button>
            </Link>
          )}
          {buttonText && buttonAction && (
            <Button
              className={cx(buttonClassName, S.PaneButton)}
              primary={!buttonDisabled}
              disabled={buttonDisabled}
              onClick={buttonAction}
            >
              {buttonIcon && <span className={S.ButtonIcon}>{buttonIcon}</span>}
              <span>{buttonText}</span>
            </Button>
          )}
        </Box>
      </Flex>
    </Box>
  );
};
